import * as React from "react";
const SvgChangeHistory = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 7.77 18.39 18H5.61L12 7.77M12 4 2 20h20L12 4z",
  fill: "currentColor"
}));
export default SvgChangeHistory;